module.exports = __webpack_public_path__ + "img/error.590b4b5f.svg";